module.exports = __webpack_public_path__ + "01_very_short_black.86b84e0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/01_very_short_black.png
// module id = Yd9b
// module chunks = 0